import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const RefundPolicy = () => {
  return (
    <div className="font-display bg-background-light dark:bg-background-dark min-h-screen">
      <div className="px-4 sm:px-10 md:px-20 lg:px-40">
        <Header />
        
        <div className="py-12 max-w-4xl mx-auto">
          <h1 className="text-4xl font-black text-gray-900 dark:text-white mb-8">
            Política de Reembolsos
          </h1>
          
          <div className="prose dark:prose-invert max-w-none">
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              Última actualización: 7 de diciembre de 2025
            </p>
            
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">1. Política General de Reembolsos</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                En GPT-JDP valoramos la satisfacción de nuestros usuarios. Esta Política de Reembolsos define las condiciones bajo las cuales se otorgan devoluciones. Al utilizar nuestros servicios, usted acepta lo aquí establecido.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">2. Período de Garantía</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Ofrecemos una garantía de satisfacción de 7 días exclusivamente para nuevas suscripciones.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                La garantía aplica solo si:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Es la primera compra de un plan.</li>
                <li>La solicitud se realiza dentro de los primeros 7 días calendario posteriores al pago.</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                <strong>Condiciones de reembolso:</strong>
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>100% del monto si el usuario ha consumido menos del 20% de los créditos.</li>
                <li>Reembolso proporcional si utilizó entre 20% y 50%.</li>
                <li>Sin reembolso si se utilizó más del 50% de los créditos incluidos en el plan.</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                La plataforma verificará automáticamente el uso real antes de autorizar cualquier devolución.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">3. Casos Elegibles para Reembolso</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Se otorgarán reembolsos en los siguientes casos:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Problemas técnicos comprobados que impidan el uso normal del servicio y no puedan resolverse dentro de 48 horas.</li>
                <li>Cobro duplicado por error.</li>
                <li>Plan incorrecto asignado por falla del sistema.</li>
                <li>Servicio no entregado tras confirmación de pago.</li>
                <li>Cancelación dentro del periodo de garantía, sujeto a condiciones de la sección 2.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">4. Casos NO Elegibles para Reembolso</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                No se realizarán reembolsos en los siguientes casos:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Solicitudes realizadas fuera del período de garantía.</li>
                <li>No uso o uso insuficiente del servicio por decisión del usuario.</li>
                <li>Violaciones a los Términos de Servicio.</li>
                <li>Uso de más del 50% de créditos durante el período de garantía.</li>
                <li>Renovaciones automáticas (el usuario debe cancelar antes de la fecha de renovación).</li>
                <li>Compra de paquetes adicionales de créditos (una vez procesados).</li>
                <li>Suscripciones anuales luego de 30 días desde la compra.</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Esto se alinea con estándares globales de plataformas SaaS.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">5. Créditos y Recargas</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Los créditos funcionan como recursos digitales y por lo tanto no son reembolsables.
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>No se reembolsan una vez procesada la compra.</li>
                <li>No caducan mientras la cuenta continúe activa.</li>
                <li>No se pueden transferir a terceros.</li>
                <li>Los créditos restantes se pierden al cerrar la cuenta, sin compensación económica.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">6. Cómo Solicitar un Reembolso</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Envía un correo a <strong>support@gpt-jdp.com</strong> con la siguiente información:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Email asociado a tu cuenta.</li>
                <li>ID de transacción.</li>
                <li>Motivo de la solicitud.</li>
                <li>Evidencia o capturas de pantalla (si aplica).</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                <strong>Tiempo de gestión:</strong>
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Revisión inicial: 3–5 días hábiles.</li>
                <li>Decisión notificada por correo electrónico.</li>
                <li>Si se aprueba: reembolso procesado en 7–10 días hábiles según el método de pago.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">7. Método de Reembolso</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Se utilizará el mismo método de pago de la compra original:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li><strong>PayPal:</strong> 1–3 días hábiles.</li>
                <li><strong>Tarjeta de crédito/débito:</strong> 5–10 días hábiles (puede variar según banco).</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                GPT-JDP no puede acelerar los tiempos de procesamiento de terceros.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">8. Cancelación de Suscripción</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                La cancelación no implica reembolso automático.
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>El usuario mantiene acceso hasta el final del período ya pagado.</li>
                <li>No se realizan cargos posteriores una vez cancelado.</li>
                <li>Para cancelar: Configuración → Suscripción → Cancelar.</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Esto es estándar en servicios digitales de suscripción.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">9. Reembolsos Parciales</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Podemos ofrecer reembolsos parciales cuando:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Se presenten problemas técnicos prolongados.</li>
                <li>El usuario realice un downgrade de plan (se prorratea la diferencia).</li>
                <li>Casos excepcionales evaluados individualmente.</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Los montos se calculan según tiempo y recursos no utilizados.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">10. Disputas y Chargebacks</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Antes de iniciar una disputa bancaria o chargeback:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Contáctenos a support@gpt-jdp.com.</li>
                <li>La mayoría de los problemas se resuelven sin escalamiento.</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                <strong>Importante:</strong>
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Iniciar un chargeback puede producir suspensión inmediata de la cuenta.</li>
                <li>Cooperaremos con investigaciones legítimas, pero protegeremos a la plataforma ante reclamos indebidos.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">11. Excepciones y Casos Especiales</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                GPT-JDP se reserva el derecho de analizar cada caso individualmente.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Podemos ofrecer soluciones alternativas como:
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 mb-4">
                <li>Créditos adicionales.</li>
                <li>Extensión de suscripción.</li>
                <li>Upgrade temporal de plan.</li>
              </ul>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Estas soluciones no constituyen obligación futura.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">12. Modificaciones a la Política</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Podemos actualizar esta política en cualquier momento.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Los cambios no afectarán solicitudes ya presentadas antes de la modificación.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">13. Contacto</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Para solicitudes de reembolso:
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-2">
                📧 support@gpt-jdp.com
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Soporte general:
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-2">
                📧 support@gpt-jdp.com
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Horario de atención:
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                🕘 Lunes a Viernes — 9:00 AM a 6:00 PM (CLT)
              </p>
            </section>
          </div>
        </div>
        
        <Footer />
      </div>
    </div>
  );
};

export default RefundPolicy;